import { Message } from "../core/message";

export class JsonRpcMessage implements Message {
    jsonrpc = "2.0";

    id?: number;

    method: string;

    params?: unknown[] | Record<string, unknown>;

    // eslint-disable-next-line
    result?: any;

    // eslint-disable-next-line
    constructor(method: string, params?: any) {
        this.method = method;
        this.params = params;
    }

    match(pattern: RegExp): boolean { return pattern.test(this.method) }

    static parse(raw: string): JsonRpcMessage {
        const { id, method, params, result } = JSON.parse(raw);

        const message = new JsonRpcMessage(method, params);
        message.id = id;
        message.result = result;

        return message;
    }
}
